var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "options-selection" }, [
    _vm.showMonths
      ? _c(
          "div",
          { staticClass: "months" },
          _vm._l(_vm.months, function (monthName, monthNumber) {
            return _c(
              "div",
              {
                key: monthNumber,
                class: _vm.monthClasses(monthNumber),
                on: {
                  click: function ($event) {
                    return _vm.$emit("set-month", +monthNumber)
                  },
                },
              },
              [
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(monthName)),
                ]),
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "years" },
          _vm._l(_vm.years, function (_year, index) {
            return _c(
              "div",
              {
                key: index,
                ref: _year === _vm.year ? "year" : null,
                refInFor: true,
                class: _vm.yearClasses(_year),
                on: {
                  click: function ($event) {
                    return _vm.$emit("set-year", +_year)
                  },
                },
              },
              [_c("span", { staticClass: "value" }, [_vm._v(_vm._s(_year))])]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }